import type { ReactNode } from "react";
import { ReviewerAvatar } from "./reviewer-avatar";
import { formatReviewDate } from "./format-review-date";

interface SpotlightReviewProps {
  review: { date?: string; name: string; profileImageUrl?: string; text: string };
  showDates: "yes" | "no";
}

// One quote, given room. The heading font carries it, so a serif theme reads
// Editorial; the aggregate badge above (showRatings) covers the numbers.
const SpotlightReview = ({ review, showDates }: SpotlightReviewProps): ReactNode => (
  <figure className="jobsite:mx-auto jobsite:max-w-3xl jobsite:text-center">
    <blockquote className="jobsite:font-heading jobsite:text-2xl jobsite:leading-snug jobsite:text-balance jobsite:text-foreground jobsite:sm:text-3xl">
      &ldquo;{review.text}&rdquo;
    </blockquote>
    <figcaption className="jobsite:mt-8 jobsite:flex jobsite:items-center jobsite:justify-center jobsite:gap-3">
      <ReviewerAvatar review={review} />
      <span className="jobsite:font-heading jobsite:text-sm jobsite:text-foreground">
        {review.name}
      </span>
      {showDates === "yes" && Boolean(review.date) && (
        <span className="jobsite:text-xs jobsite:text-muted-foreground">
          {formatReviewDate(review.date)}
        </span>
      )}
    </figcaption>
  </figure>
);

export { SpotlightReview };
